import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import formatPhone from "@shared/filters/phone.js";
import type { SalesRep } from "@shared/types/SalesRep";

export const formatContactString = (rep: SalesRep, addComma: boolean = false) => {
  let contactString = "";

  if (rep.name) {
    contactString += rep.name;

    if (rep.sanitized_email && rep.sanitized_phone) {
      contactString += ` (${rep.sanitized_email}, ${formatPhone(rep.sanitized_phone)})`;
    } else if (rep.sanitized_email || rep.sanitized_phone) {
      contactString += ` (${rep.sanitized_email || ""}${formatPhone(rep.sanitized_phone)})`;
    }
    if (addComma) contactString += ", ";
  }

  return contactString;
};

export async function removeSalesRepMatch(
  salesRep: SalesRep,
): Promise<{ status: "error" | "success" }> {
  try {
    await HttpPromise({
      method: "DELETE",
      url: `/api/retailer/distributors/${salesRep.distributor_id}/sales_rep_assignments/${salesRep.id}`,
    });

    return { status: "success" };
  } catch (e) {
    return { status: "error" };
  }
}
